import { withPublicImageUrl } from '@lib/utils/cdn'

import { Column } from '@components/ui-core/column/column'
import { Image } from '@components/ui-core/image/image'
import { Row } from '@components/ui-core/row/row'
import { Text } from '@components/ui-core/text/text'

import {
  TestimonialCompanies,
  type TestimonialCompany,
  type PlansPageData,
  type Testimonial as TestimonialData,
} from '../types'

import styles from './testimonials.module.scss'

export const Testimonials = ({ data }: { readonly data: PlansPageData['testimonialsSection'] }) => (
  <Column className={styles.testimonials} mainAxisAlignment="start" crossAxisAlignment="center">
    <Column className={styles.container} mainAxisAlignment="start" crossAxisAlignment="center">
      <Text as="h3" variant="headerMedium" className={styles.title}>
        {data.title}
      </Text>
      <Row className={styles.row} mainAxisAlignment="start" crossAxisAlignment="start">
        {TestimonialCompanies.map(company => (
          <Testimonial key={company} company={company} testimonial={data.testimonials[company]} />
        ))}
      </Row>
    </Column>
  </Column>
)

const Testimonial = ({
  company,
  testimonial,
}: {
  readonly company: TestimonialCompany
  readonly testimonial: TestimonialData
}) => {
  const { quote, name, position } = testimonial
  const image = `plans-testimonials-${company}`
  return (
    <Column className={styles.item}>
      <Row
        mainAxisAlignment="spaceBetween"
        crossAxisAlignment="center"
        gap="8x"
        className={styles.images}
      >
        <img
          className={styles.photo}
          src={withPublicImageUrl(`${image}.png`)}
          alt={`${company} representative photo`}
        />
        <Image
          src={withPublicImageUrl(`${image}.svg`)}
          alt={`${company} company logo`}
          className={styles.logo}
        />
      </Row>
      <blockquote className={styles.quote}>
        <span>{quote}</span>
      </blockquote>
      <Column>
        <span className={styles.name}>{name}</span>
        <span className={styles.position}>{position}</span>
      </Column>
    </Column>
  )
}
